import { Box, Grid, Typography } from '@material-ui/core'
import BrandsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/BrandsFragment'
import PartsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/PartsFragment'
import ProductsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/ProductsFragment'
import ActionFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/ActionFragment'
import useReplacementPartsCatalogStrategy from './utils/useReplacementPartsCatalogStrategy'
import css from './ReplacementPartsCatalogStrategy.styles.scss'

export default function ReplacementPartsCatalogStrategy() {
  const { brandsController, productsController, partsController } =
    useReplacementPartsCatalogStrategy()

  return (
    <div className={css.ReplacementPartsCatalogStrategy}>
      <Box m="auto" maxWidth={400}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={css.ReplacementPartsCatalogStrategy__hero}>
              <p className={css.ReplacementPartsCatalogStrategy__hero__title}>
                You're eligible for free replacement parts!
              </p>
              <Typography variant="body2">
                Fill out the information below, to get breast pump replacement
                parts through your insurance. We'll even cover the shipping.
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12}>
            <Typography gutterBottom variant="body2">
              Tell us about your breast pump.
            </Typography>
          </Grid>

          <BrandsFragment controller={brandsController} />

          <ProductsFragment
            controller={productsController}
            key={brandsController.selected?.brand}
          />

          <PartsFragment
            controller={partsController}
            key={productsController.selected?.id}
          />

          <ActionFragment
            brandsController={brandsController}
            key={`${productsController.selected?.id}-${partsController.selected?.id}`}
            partsController={partsController}
            productsController={productsController}
          />
        </Grid>
      </Box>
    </div>
  )
}
